export type TierType =
  | 'skymiles'
  | 'silver'
  | 'gold'
  | 'platinum'
  | 'diamond'
  | '360';

export type LevelType =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20';
